// 导入组件，组件必须声明 name
import ElectronicSignature from "./src/main";
// 为组件添加 install 方法，用于按需引入
ElectronicSignature.install = function (Vue) {
  Vue.component(ElectronicSignature.name, ElectronicSignature);
};
export default ElectronicSignature;